export const getFiltersButtonText = (
    source: string | null,
    status: string | null,
    period: string | null,
    dateFrom: string | null,
    dateTo: string | null,
) => {
    let selectedFiltersCount = 0;

    if (source) {
        selectedFiltersCount++;
    }

    if (status) {
        selectedFiltersCount++;
    }

    if (period || dateFrom || dateTo) {
        selectedFiltersCount++;
    }

    if (selectedFiltersCount) {
        return `Фильтры・${selectedFiltersCount}`;
    }

    return 'Фильтры';
};
